import React from 'react'
import { IconButton, InputAdornment, TextField } from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import { useState } from 'react'

const PasswordInput = ({ password, handlePassword, error }) => {
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <TextField
      type={showPassword ? 'text' : 'password'}
      id="password"
      name="password"
      margin="normal"
      className="margin-top-medium"
      placeholder="Password"
      value={password}
      onChange={handlePassword}
      error={error}
      helperText={error}
      data-cy="input-password"
      inputProps={{ style: { padding: '15px 20px' } }}
      InputProps={{
        classes: {
          underline: 'thick-underlined',
        },
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              style={{ backgroundColor: 'transparent' }}
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}

export default PasswordInput



// WEBPACK FOOTER //
// ./src/components/common/PasswordInput.js